import React from "react";

const Form = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36", isRegular = false}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        {!isRegular ?
            <path className="u_fill"
               fill={fill}
               d="M32.444 13.2v19.188c0 .894-.702 1.612-1.57 1.612H5.57C4.703 34 4 33.29 4 32.413V3.587C4 2.728 4.706 2 5.577 2h15.806v9.6c0 .884.707 1.6 1.58 1.6h9.481Zm0-3.2h-7.9V2.005l7.9 7.995Zm-20.543 0v3.2h4.741V10h-4.74Zm0 6.4v3.2h12.642v-3.2H11.901Zm0 6.4V26h12.642v-3.2H11.901Z"
        />
        :<React.Fragment>
                <path
                    className="u_fill"
                    fill={fill}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={3.111}
                    d="M21 4v6.222a1.556 1.556 0 0 0 1.556 1.556h6.222"
                />
                <path
                    stroke={fill || "#4E525F"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={3.111}
                    d="M25.667 32H10.11A3.111 3.111 0 0 1 7 28.889V7.11A3.111 3.111 0 0 1 10.111 4H21l7.778 7.778v17.11A3.111 3.111 0 0 1 25.667 32ZM13.222 13.333h1.556M13.222 19.555h9.334M13.222 25.778h9.334"
                />
        </React.Fragment>}
    </svg>
);

export default Form;